module.exports = __webpack_public_path__ + "media/recipes/8-d477ffc2.png";